import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private static readonly REVIO_PARENT_PREFIX = 'revio-parent:';

  getRevioParentCustomerId(domain: string): number | null {
    try {
      const cached = Number(
        localStorage.getItem(`${StorageService.REVIO_PARENT_PREFIX}${domain}`) || '0'
      );
      return cached > 0 ? cached : null;
    } catch {
      return null;
    }
  }

  setRevioParentCustomerId(domain: string, customerId: number): void {
    try {
      localStorage.setItem(
        `${StorageService.REVIO_PARENT_PREFIX}${domain}`,
        String(customerId)
      );
    } catch {
      // Ignore localStorage errors
    }
  }

  removeRevioParentCustomerId(domain: string): void {
    try {
      localStorage.removeItem(`${StorageService.REVIO_PARENT_PREFIX}${domain}`);
    } catch {
      // Ignore localStorage errors
    }
  }
}

